import React, { useState, useEffect } from "react";
import { useAppSelector } from "../../../context-store";
import interviewerService from '../../../services/interviewer/interviewer-service';
import toasterUtils from "../../../utils/toaster-utils";
import modalUtils from "../../../utils/modal-utils";
import ConfirmScheduleDetailsModel from "../../../models/interviewer/response/ConfirmScheduleDetailsModel";
import fileUtils from "../../../utils/file-utils";
import candidateService from '../../../services/candidate/candidate-service';
import { FileUploadTypeEnum } from "../../../models/enums/FileUploadTypeEnum";
import { Button } from "@mui/material";

interface ConfirmInterviewProps {
    interviewId: string;
    candidateId: string;
    resumeTitle: string;
    isConfirmedByInterviewer: string;
    onConfirmInterview: (interviewId: string) => void;
}

const ConfirmInterviewComponent = function (props: ConfirmInterviewProps) {
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    const [interviewDetails, setInterviewDetails] = useState<ConfirmScheduleDetailsModel>();

    useEffect(() => {
        getInterviewDetails();
    }, []);

    const getInterviewDetails = () => {
        interviewerService.getInterviewDetails(props.interviewId).then((res) => {
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setInterviewDetails(res.data);
        }).catch((error) => {
            toasterUtils.showError("Erorr fetching Details" + error);
        });
    };

    const confirmInterview = () => {
        props.onConfirmInterview(props.interviewId);
    }

    const downloadCandidateResume = () => {
        if (loggedInUser && interviewDetails) {
            candidateService.downloadCandidateResume(props.candidateId, FileUploadTypeEnum.CandidateResume.toString()).then((res) => {
                fileUtils.downloadFile(res, props.resumeTitle);
            }).catch((error) => {
                toasterUtils.showError(error);
            });
        }
    }

    return (
        <div>
            <div className="row mb-2">
                <div className="col-lg-12 col-md-12">
                    <div className="row mb-2">
                        <div className="col-lg-4 col-md-4 interview-details-label">
                        Interview Date:
                        </div>
                        <div className="col-lg-8 col-md-8 int-date-time">
                                {interviewDetails?.interviewDate} 
                        </div>
                    </div>                        
                </div>
                <div className="col-lg-12 col-md-12">
                    <div className="row mb-2">
                        <div className="col-lg-4 col-md-4 interview-details-label">
                        Interview  Time:
                        </div>
                        <div className="col-lg-8 col-md-8 int-date-time">
                                {interviewDetails?.timeSlotName}
                        </div>
                    </div>
                </div>
                <div className="col-lg-12 col-md-12">
                    <div className="row mb-2">
                        <div className="col-lg-4 col-md-4 interview-details-label">
                        Mobile Number:
                        </div>
                        <div className="col-lg-8 col-md-8">
                        {interviewDetails?.mobileNumber}
                        </div>
                    </div>
                </div>
                <div className="col-lg-12 col-md-12">
                    <div className="row mb-2">
                        <div className="col-lg-4 col-md-4 interview-details-label">
                        Primary Skill:
                        </div>
                        <div className="col-lg-8 col-md-8">
                        {interviewDetails?.primarySkillName}
                        </div>
                    </div>
                </div>
                <div className="col-lg-12 col-md-12">
                        {interviewDetails?.secondarySkills.map(field => (
                            <div className="row mb-2">
                                <div className="col-md-4 interview-details-label">Secondary Skill {field.secondarySkillNumber}:</div>
                                <div className="col-md-8">{field.secondarySkillName}</div>
                            </div>
                        ))}
                </div>
                <div className="col-lg-12 col-md-12">
                    <div className="row mb-2">
                        <div className="col-lg-4 col-md-4 interview-details-label">
                        Client Inputs:
                        </div>
                        <div className="col-lg-8 col-md-8">
                        {interviewDetails?.keyResponsibilities}
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                {props.resumeTitle && props.resumeTitle !== "" &&
                    <>
                        <div className="col-md-4 interview-details-label">Resume:</div>
                        <div className="col-md-8">
                            <a title="Import File, Please do not import files with the same name." onClick={downloadCandidateResume}>
                                <i className="fa fa-download"></i> <span>Download Resume</span>
                            </a>
                        </div>
                    </>
                }
            </div>
            <div className="row">                
                <div className="col-md-12 text-end mt-2">
                    {props.isConfirmedByInterviewer === "False" &&
                        <Button variant="contained" color="primary" onClick={() => confirmInterview()}>
                            Confirm
                        </Button>
                    }
                    <Button variant="contained" color="error" onClick={() => modalUtils.closeModal()}>
                        Close
                    </Button>
                </div>
            </div>
        </div>
    );
};
export default ConfirmInterviewComponent;